export default "__VITE_ASSET__f3374023__"